import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../../icon.interface';
const BillingExceedsMaxAmount = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="183"
        height="200"
        viewBox="0 0 183 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M162.491 35.8821C175.08 53.4071 181.887 70.8789 182.412 87.4395C183.001 104.002 177.324 119.705 169.828 135.891C162.33 152.024 152.958 168.637 140.374 170.834C127.789 172.978 111.991 160.758 94.7488 153.846C77.4446 146.984 58.7089 145.484 47.0267 135.141C35.3594 124.744 30.8074 105.503 33.1642 86.7433C35.5743 67.9857 44.9996 49.7007 59.4576 32.5589C73.971 15.3553 93.6236 -0.724166 112.581 0.0252024C131.591 0.7767 149.958 18.3549 162.491 35.8821Z"
          fill="#E8F0FF"
        />
        <path
          d="M93.509 23.9482H2.45535C1.19422 23.9482 0.171875 24.8311 0.171875 25.9201V107.26C0.171875 108.349 1.19422 109.231 2.45535 109.231H93.509C94.7701 109.231 95.7924 108.349 95.7924 107.26V25.9201C95.7924 24.8311 94.7701 23.9482 93.509 23.9482Z"
          fill="#F9F9F9"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.29558 24.2927H93.8414C95.1093 24.2927 96.1372 25.3898 96.1372 26.7431V32.5626H-0.000244141V26.7431C-0.000244141 25.3898 1.02763 24.2927 2.29558 24.2927Z"
          fill="#B2B2B2"
        />
        <path
          d="M3.87469 29.7635C4.58834 29.7635 5.16686 29.185 5.16686 28.4714C5.16686 27.7577 4.58834 27.1792 3.87469 27.1792C3.16104 27.1792 2.58252 27.7577 2.58252 28.4714C2.58252 29.185 3.16104 29.7635 3.87469 29.7635Z"
          fill="#F9F9F9"
        />
        <path
          d="M7.31854 29.7635C8.03218 29.7635 8.61071 29.185 8.61071 28.4714C8.61071 27.7577 8.03218 27.1792 7.31854 27.1792C6.60489 27.1792 6.02637 27.7577 6.02637 28.4714C6.02637 29.185 6.60489 29.7635 7.31854 29.7635Z"
          fill="#F9F9F9"
        />
        <path
          d="M10.7621 29.7635C11.4758 29.7635 12.0543 29.185 12.0543 28.4714C12.0543 27.7577 11.4758 27.1792 10.7621 27.1792C10.0485 27.1792 9.46997 27.7577 9.46997 28.4714C9.46997 29.185 10.0485 29.7635 10.7621 29.7635Z"
          fill="#F9F9F9"
        />
        <path
          d="M89.208 37.7314H6.7561C4.54696 37.7314 2.7561 39.5223 2.7561 41.7314V60.4363C2.7561 62.6454 4.54697 64.4363 6.7561 64.4363H89.208C91.4171 64.4363 93.208 62.6454 93.208 60.4363V41.7314C93.208 39.5223 91.4171 37.7314 89.208 37.7314Z"
          fill="#FFE8EB"
        />
        <path
          d="M18.4111 61.852C24.1752 61.852 28.8479 57.2238 28.8479 51.5146C28.8479 45.8054 24.1752 41.1772 18.4111 41.1772C12.6471 41.1772 7.97437 45.8054 7.97437 51.5146C7.97437 57.2238 12.6471 61.852 18.4111 61.852Z"
          fill="#E90200"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.585 50.1017L21.2553 47.4568L22.4678 48.6809L19.8091 51.3142L22.8441 54.3202L21.6317 55.5443L18.585 52.5267L15.5384 55.5443L14.3259 54.3202L17.3609 51.3142L14.7022 48.6809L15.9147 47.4568L18.585 50.1017Z"
          fill="white"
        />
        <path
          d="M83.9893 69.605H11.1045C8.89535 69.605 7.10449 71.3958 7.10449 73.605V81.111C7.10449 83.3202 8.89536 85.111 11.1045 85.111H83.9894C86.1985 85.111 87.9894 83.3202 87.9894 81.111V73.605C87.9894 71.3958 86.1985 69.605 83.9893 69.605Z"
          fill="#FFFCE0"
        />
        <path
          d="M16.6717 82.5266C19.5538 82.5266 21.8901 80.2125 21.8901 77.3579C21.8901 74.5033 19.5538 72.1892 16.6717 72.1892C13.7897 72.1892 11.4534 74.5033 11.4534 77.3579C11.4534 80.2125 13.7897 82.5266 16.6717 82.5266Z"
          fill="#ED9F38"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.8103 78.2193V73.9121H17.5332V78.2193H15.8103Z"
          fill="white"
        />
        <ellipse
          cx="16.6717"
          cy="79.9423"
          rx="0.86973"
          ry="0.861446"
          fill="white"
        />
        <path
          d="M84.8592 88.5569H11.9744C9.76523 88.5569 7.97437 90.3477 7.97437 92.5569V100.063C7.97437 102.272 9.76523 104.063 11.9744 104.063H84.8592C87.0684 104.063 88.8592 102.272 88.8592 100.063V92.5569C88.8592 90.3477 87.0684 88.5569 84.8592 88.5569Z"
          fill="#E4F7E0"
        />
        <path
          d="M16.6717 101.478C19.5538 101.478 21.8901 99.1644 21.8901 96.3098C21.8901 93.4552 19.5538 91.1411 16.6717 91.1411C13.7897 91.1411 11.4534 93.4552 11.4534 96.3098C11.4534 99.1644 13.7897 101.478 16.6717 101.478Z"
          fill="#4DAC44"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.7731 96.2919L18.9865 94.0708L20.2185 95.2753L16.7811 98.7247L14.3201 96.2871L15.5442 95.0746L16.7731 96.2919Z"
          fill="white"
        />
        <path
          d="M80.282 104.104C79.9771 105.171 75.0985 130.937 83.4836 154.872C84.8558 155.177 84.7033 151.366 84.7033 151.366L83.1787 118.587L83.941 106.238L80.282 104.104Z"
          fill="#FFB688"
        />
        <path
          d="M103.151 200H88.3624C88.3624 200 83.3313 148.012 83.3313 146.945C84.246 147.859 84.0936 148.164 87.905 149.231C90.1919 151.671 106.352 192.225 106.352 192.225L103.151 200Z"
          fill="#065BDC"
        />
        <path
          d="M95.8037 84.7418C102.928 86.7802 97.3023 108.542 94.6648 110.365C92.0273 112.189 79.663 107.057 78.6659 104.749C77.6688 102.441 85.7171 81.8558 95.8037 84.7418Z"
          fill="#0F3893"
        />
        <path
          d="M102.236 78.9487C124.952 78.9487 125.409 144.201 122.208 146.945C119.006 149.689 86.2278 152.281 83.3311 146.945C80.4344 141.609 77.5377 78.9487 102.236 78.9487Z"
          fill="#0F3893"
        />
        <rect
          x="89.4182"
          y="90.4519"
          width="19.9956"
          height="13.747"
          rx="1.86896"
          transform="rotate(59.8572 89.4182 90.4519)"
          fill="#065BDC"
        />
        <rect
          x="86.9326"
          y="91.8945"
          width="19.9956"
          height="2.2495"
          transform="rotate(59.8572 86.9326 91.8945)"
          fill="#AECCFF"
        />
        <rect
          x="84.6865"
          y="96.6675"
          width="6.99845"
          height="0.874807"
          transform="rotate(59.8572 84.6865 96.6675)"
          fill="#AECCFF"
        />
        <path
          d="M110.469 83.3698C116.415 78.9485 130.288 96.6336 130.136 99.8352C129.983 103.037 118.397 109.745 115.957 109.135C113.518 108.525 102.05 89.6297 110.469 83.3698Z"
          fill="#0F3893"
        />
        <path
          d="M128.001 100.445C133.642 109.745 135.167 122.094 135.167 124.228C135.167 130.022 132.27 132.919 130.441 132.919C123.123 132.919 99.0344 114.319 97.3573 112.794C95.6803 111.27 100.559 106.696 101.321 107.458C102.084 108.22 110.774 113.709 123.428 119.197C121.598 116.91 116.262 110.05 116.11 107.915C115.957 105.781 128.001 100.445 128.001 100.445Z"
          fill="#FFB688"
        />
        <path
          d="M106.2 81.8452C106.2 83.8271 98.272 83.9796 98.272 81.8452V69.801H106.2V81.8452Z"
          fill="#DB9D76"
        />
        <path
          d="M100.178 76.9666C104.514 76.9666 108.03 70.7211 108.03 63.0168C108.03 55.3125 104.514 49.0669 100.178 49.0669C95.8417 49.0669 92.3264 55.3125 92.3264 63.0168C92.3264 70.7211 95.8417 76.9666 100.178 76.9666Z"
          fill="#FFB688"
        />
        <path
          d="M107.495 67.0568C108.632 67.0568 109.554 66.1353 109.554 64.9986C109.554 63.8619 108.632 62.9404 107.495 62.9404C106.359 62.9404 105.437 63.8619 105.437 64.9986C105.437 66.1353 106.359 67.0568 107.495 67.0568Z"
          fill="#FFB688"
        />
        <path
          d="M134.252 47.0849C128.306 47.0849 123.427 51.3537 117.024 51.3537C112.451 51.3537 108.029 45.8652 101.626 45.8652C93.3933 45.8652 90.8015 50.2865 90.8015 53.3357C90.8015 55.775 92.3261 58.5192 92.7835 58.5192C92.7835 57.7569 93.6982 55.0127 94.0031 54.7078C94.308 55.775 100.711 63.2454 106.352 63.2454V63.2881C106.662 63.0808 107.022 62.9615 107.395 62.943C107.767 62.9245 108.138 63.0076 108.466 63.1832C108.795 63.3588 109.07 63.6205 109.262 63.9403C109.454 64.26 109.555 64.6258 109.555 64.9987C109.555 65.3715 109.454 65.7373 109.262 66.0571C109.07 66.3768 108.795 66.6385 108.466 66.8141C108.138 66.9898 107.767 67.0728 107.395 67.0543C107.022 67.0358 106.662 66.9166 106.352 66.7092V71.1732H107.877C109.859 71.1732 110.773 70.4109 113.823 70.4109C119.159 70.4109 126.629 76.9666 135.777 76.9666C145.686 76.9666 149.803 69.4962 149.803 61.111C149.803 49.9816 139.283 47.0849 134.252 47.0849Z"
          fill="#0B0B0B"
        />
        <path
          d="M122.208 146.945V200H103.151L87.8867 149.196C93.241 150.146 113.518 150.908 122.208 146.945Z"
          fill="#74AAFF"
        />
        <path
          d="M101.013 110.927C102.15 108.958 100.854 106.082 98.1198 104.504C95.3853 102.925 92.2471 103.241 91.1104 105.21C89.9737 107.179 91.269 110.054 94.0035 111.633C96.7379 113.212 99.8761 112.896 101.013 110.927Z"
          fill="#FFB688"
        />
      </svg>
    );
  }
);
export default BillingExceedsMaxAmount;
